import Vue from "vue";
import Vuex from "vuex";
import VueRouter from 'vue-router';
import router from './router';
import store from './store/index'
import VueCountdownTimer from 'vuejs-countdown-timer';
import FileSelector from "vue-file-selector";

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueCountdownTimer);
Vue.use(FileSelector);

Vue.mixin({
    methods: {
        trans(value) {
            return window.trans(value, 'form')
        },

        chooseAnswer(answerId, question, value = true) {
            this.$store.commit('addUserAnswer', {answerId, question, add: value})
        },

        writeAnswer(answerText, question) {
            this.$store.commit('addUserTextAnswer', {answerText, question})
        },

        writeAnswerFile(file, question) {
            this.$store.commit('addUserFileAnswer', {file, question})
        },

        removeFile(index, question) {
            this.$store.commit('removeUserFileAnswer', {index, question})
        }
    },
    computed: {
        activeQuiz() {
            return this.$store.state.activeQuiz
        },
        m_cloud_url() {
            return window.m_cloud_url;
        },
    }
})

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

new Vue({
    el: '#TenantFormsApp',
    router,
    store
});
